(function () {
	const root = document.querySelector('[data-resource-search]');
	if (!root) return;

	const input = root.querySelector('[data-resource-search-input]');
	const select = root.querySelector('[data-resource-search-category]');
	const results = root.querySelector('[data-resource-search-results]');

	if (!input || !select || !results) return;

	const config = window.bayalarmResourceSearch || {};
	const ajaxUrl = config.ajaxUrl;
	if (!ajaxUrl) return;

	const featured = root.getAttribute('data-resource-featured') || '';

	function fetchResults(paged) {
		const data = new FormData();
		data.append('action', 'bayalarm_resource_search');
		data.append('s', input.value);
		data.append('cat', select.value);
		data.append('paged', paged || 1);
		data.append('featured', featured);

		results.classList.add('is-loading');

		fetch(ajaxUrl, { method: 'POST', body: data, credentials: 'same-origin' })
			.then(function (r) {
				return r.json();
			})
			.then(function (json) {
				results.classList.remove('is-loading');
				if (json && json.success) {
					results.innerHTML = json.data.html;
				}
			})
			.catch(function () {
				results.classList.remove('is-loading');
			});
	}

	input.addEventListener('keydown', function (e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			fetchResults(1);
		}
	});

	select.addEventListener('change', function () {
		fetchResults(1);
	});

	results.addEventListener('click', function (e) {
		const link = e.target.closest('[data-paged]');
		if (!link) return;
		e.preventDefault();
		const paged = parseInt(link.getAttribute('data-paged'), 10) || 1;
		fetchResults(paged);
		results.scrollIntoView({ behavior: 'smooth', block: 'start' });
	});
})();
